import { useState } from 'react'

/**
 * useDisclosure is a custom hook to help control the open/close state
 * of things like modal, drawers and alerts.
 */
export const useDisclosure = () => {
  const [isOpen, setIsOpen] = useState(false)

  const onOpen = () => {
    setIsOpen(true)
  }

  const onClose = () => {
    setIsOpen(false)
  }

  return { isOpen: !!isOpen, onOpen, onClose }
}
